export default __webpack_public_path__ + "static/media/poste1.86e69484.jpg";